import { render, staticRenderFns } from "./BalancesPlanAdd.vue?vue&type=template&id=55b8d57c&scoped=true&"
import script from "./BalancesPlanAdd.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8d57c",
  null
  
)

export default component.exports